module.exports = __webpack_public_path__ + "img/catetrine.0bf3519e.jpg";